import Vue from 'vue' ;
import { namespace } from 'vuex-class' ;
import { BLOCK_MODULE_NAMESPACE, BLOCK_SET_BLOCK_BY_FIELD } from '../../../../store/block';
import { IBlock } from '../../../../models/block';
import { IAddress } from '../../../../models/address/address.model';

const BlockStore= namespace(BLOCK_MODULE_NAMESPACE)

export class BlockViewModal extends Vue {

    @BlockStore.Getter block : IBlock

    @BlockStore.Mutation(BLOCK_SET_BLOCK_BY_FIELD)
    storeAssignValueForBlock: (payload: IBlock) => void;
    

    get Label(){
        return this.block.name
    }

    set Label(value: string){
        this.storeAssignValueForBlock({ name: value })
    }

    get address(): IAddress{
        return this.block.address
    }

    set address(value: IAddress){
        this.storeAssignValueForBlock({ address: value })
    }

    get attachment(){
        return this.block.attachment
    }

    set attachment(value:any){
        this.storeAssignValueForBlock({ attachment: value })
    }

    get nbreLots(){
        return this.block.nbreLots
    }

    set nbreLots(value: number ){
        this.storeAssignValueForBlock({ nbreLots: value  })
    }

    get digicode(){
        return this.block.digicode
    }

    set digicode(value: string ){
        this.storeAssignValueForBlock({ digicode: value })
    }

    get concierge(): number[] {
        return this.block.concierge
    }

    set concierge(value: number[]){
        this.storeAssignValueForBlock({ concierge: value })
    }

    get commercial(): number[] {
        return this.block.commercial
    }

    set commercial(value : number[]){
        this.storeAssignValueForBlock({ commercial: value })
    }

    get managers_list(){
        return this.block.managers
    }

    set managers_list(value: number[] ){
        this.storeAssignValueForBlock({ managers: value })
    }


}


// WEBPACK FOOTER //
// ./src/containers/block/components/block-modal-vertical/block.viewmodal.ts